export enum CallState {
    Closed = "closed",
    HairCheck = "hair_check",
    InCall = "in_call",
}
